import React from 'react'
import styled from 'styled-components'
import { Trans } from 'react-i18next'

import { DATABASE_TOOLTIPS } from 'constants/product_database/tooltips'
import { QuestionIcon } from 'icons/QuestionIcon/QuestionIcon'
import { productType } from 'src/js/types/product'
import { NoDataTooltip } from 'ui_elements/NoDataTooltip/NoDataTooltip'
import { Tooltip } from '@junglescout/edna'

const ReviewsWrapper = styled.div`
  display: flex;
`

const StyledQuestionIcon = styled(QuestionIcon)`
  opacity: 50%;
`
const IconWrapper = styled.div`
  margin-left: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ReviewsCell = ({ product }) => {
  const { nReviews, variantAsinsCount } = product

  if (!nReviews) {
    return (
      <NoDataTooltip
        content={DATABASE_TOOLTIPS.nullProductData.reviews}
        size="medium"
      />
    )
  }

  if (variantAsinsCount) {
    return (
      <ReviewsWrapper>
        <div>{Math.round(product.nReviews)?.toLocaleString()}</div>
        <Tooltip
          size="170px"
          side="bottom"
          content={
            <Trans i18nKey="product_database:DatabaseTable.reviewsAverage">
              Average number of reviews for all variants
            </Trans>
          }>
          <IconWrapper>
            <StyledQuestionIcon size="12px" />
          </IconWrapper>
        </Tooltip>
      </ReviewsWrapper>
    )
  }

  return nReviews
}

ReviewsCell.propTypes = {
  product: productType.isRequired
}
